// ----------------------------------------------------------------------
import { Resources } from '../pages/admin/resources/resource';
const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/',
  BASE_PATH: '',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    analytics: `${ROOTS.BASE_PATH}/analytics`,
    account: `${ROOTS.BASE_PATH}/player`,
    v2: {
      root: `${ROOTS.BASE_PATH}/dashboard-v2`,
    },
    v3: {
      root: `${ROOTS.BASE_PATH}/dashboard-v3`,
    },
    perpetualTrading: {
      root: `${ROOTS.BASE_PATH}/perpetual-trading`,
    },
    xbitRelay: {
      root: ROOTS.BASE_PATH,
      hotWallets: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayHotWallets}`,
      },
      deposits: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayDeposits}`,
      },
      withdrawals: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayWithdrawals}`,
      },
      transfers: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayTransfers}`,
      },
      sweepMonitor: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelaySweepMonitor}`,
      },
      sweepHistory: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelaySweepHistory}`,
      },
      depositWallets: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayDepositWallets}`,
      },
      withdrawalProviderConfigs: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayWithdrawalProviderConfigs}`,
      },
      transactionRescan: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayTransactionRescan}`,
      },
      hotWalletBalancer: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayHotWalletBalancer}`,
      },
      providerAudit: {
        root: `${ROOTS.BASE_PATH}/${Resources.xbitRelayProviderAudit}`,
      },
    },
    vaultDashboard: {
      root: `${ROOTS.BASE_PATH}/vault/dashboard`,
    },
    vaultParams: {
      root: `${ROOTS.BASE_PATH}/vault/params`,
    },
    vaultOfficialVaults: {
      root: `${ROOTS.BASE_PATH}/vault/official-vaults`,
    },
    vaultVaults: {
      root: `${ROOTS.BASE_PATH}/vault/vaults`,
    },
    vaultInvestors: {
      root: `${ROOTS.BASE_PATH}/vault/investors`,
    },
    vaultRecords: {
      root: `${ROOTS.BASE_PATH}/vault/records`,
    },
    vaultReconciliation: {
      root: `${ROOTS.BASE_PATH}/vault/reconciliation`,
    },
    vaultOperations: {
      root: `${ROOTS.BASE_PATH}/vault/operations`,
    },
    xpxPerpsWithdrawal: {
      root: `${ROOTS.BASE_PATH}/xpx-perps/withdrawal`,
    },
    xpxPerpsChainConfigs: {
      root: `${ROOTS.BASE_PATH}/xpx-perps/chain-token-config/chains`,
    },
    xpxPerpsTokenConfigs: {
      root: `${ROOTS.BASE_PATH}/xpx-perps/chain-token-config/tokens`,
    },
    perpsV1Views: {
      root: `${ROOTS.BASE_PATH}/${Resources.perpsV1Views}`,
    },
    perpsV1Pins: {
      root: `${ROOTS.BASE_PATH}/${Resources.perpsV1Pins}`,
    },
    perpsV1Sectors: {
      root: `${ROOTS.BASE_PATH}/${Resources.perpsV1Sectors}`,
    },
    perpsV1Symbols: {
      root: `${ROOTS.BASE_PATH}/${Resources.perpsV1Symbols}`,
    },
    perpsV1Presets: {
      root: `${ROOTS.BASE_PATH}/${Resources.perpsV1Presets}`,
    },
    predictionTrading: {
      root: `${ROOTS.BASE_PATH}/prediction-trading`,
    },
    proxyManager: {
      root: `${ROOTS.BASE_PATH}/proxy-manager`,
    },
    notificationConfigs: {
      root: `${ROOTS.BASE_PATH}/notification-configs`,
    },
    game: {
      root: `${ROOTS.BASE_PATH}/game`,
      gameDetail: `${ROOTS.BASE_PATH}/game-detail`,
      gameRule: `${ROOTS.BASE_PATH}/game-rule`,
      gameDocument: `${ROOTS.BASE_PATH}/game-document`,
      staticConfig: `${ROOTS.BASE_PATH}/static-config`,
    },
    transaction: `${ROOTS.BASE_PATH}/transaction`,
    agency: {
      root: `${ROOTS.BASE_PATH}/agency`,
      create: `${ROOTS.BASE_PATH}/agency/create`,
      new: `${ROOTS.BASE_PATH}/agency/new`,
      edit: (id: string) => `${ROOTS.BASE_PATH}/agency/${id}/edit`,
    },
    users: {
      root: `${ROOTS.BASE_PATH}/users`,
    },

    roles: {
      root: `${ROOTS.BASE_PATH}/roles`,
    },
    groups: {
      root: `${ROOTS.BASE_PATH}/groups`,
    },
    tokenMetadata: {
      root: `${ROOTS.BASE_PATH}/token/metadatas`,
    },
    tokenOnchainInfo: {
      root: `${ROOTS.BASE_PATH}/token/onchain-infos`,
    },
    tokenStock: {
      root: `${ROOTS.BASE_PATH}/token/x-stocks`,
    },
    systemRpc: {
      root: `${ROOTS.BASE_PATH}/system/rpc`,
    },
    systemRpc_v2: {
      root: `${ROOTS.BASE_PATH}/system/rpc_v2`,
    },
    systemProxy: {
      root: `${ROOTS.BASE_PATH}/system/proxy`,
    },
    crawlerMonitor: {
      root: `${ROOTS.BASE_PATH}/system/crawler-monitor`,
    },
    cronMonitor: {
      root: `${ROOTS.BASE_PATH}/system/cron-monitor`,
    },
    maintenance: {
      root: `${ROOTS.BASE_PATH}/system/maintenance`,
    },
    tradingTrade: {
      root: `${ROOTS.BASE_PATH}/trading/trade`,
    },
    tradingSniper: {
      root: `${ROOTS.BASE_PATH}/trading/sniper`,
    },
    tradingFeeManagementScreen: {
      root: `${ROOTS.BASE_PATH}/trading/fee-management`,
    },
    tradingTelegramApp: {
      root: `${ROOTS.BASE_PATH}/trading/telegramApp`,
    },

    home: {
      root: `${ROOTS.BASE_PATH}/home`,
      categories: {
        root: `${ROOTS.BASE_PATH}/home/categories`,
      },
    },
    smartMoney: {
      root: `${ROOTS.BASE_PATH}/smart-money`,
    },
    config: {
      root: `${ROOTS.BASE_PATH}/configs`,
      trandingToken: {
        root: `${ROOTS.BASE_PATH}/configs/tranding-tokens`,
      },
      searchPlaceholder: {
        root: `${ROOTS.BASE_PATH}/configs/search-placeholders`,
      },
      color: {
        root: `${ROOTS.BASE_PATH}/configs/colors`,
      },
      adminConfig: {
        root: `${ROOTS.BASE_PATH}/configs/admin-configs`,
      },
    },
    transactions: {
      root: `${ROOTS.BASE_PATH}/transactions`,
    },
  },

  userManagement: {
    userInfo: {
      root: `${ROOTS.BASE_PATH}/user-management/user-info`,
      show: (id: string) => `${ROOTS.BASE_PATH}/user-management/user-info/${id}/show`,
    },
    userFeedback: {
      root: `${ROOTS.BASE_PATH}/user-management/user-feedback`,
      show: (id: string) => `${ROOTS.BASE_PATH}/user-management/user-feedback/${id}/show`,
    },
    tradingRetention: {
      root: `${ROOTS.BASE_PATH}/user-management/trading-retention`,
    },
    referralRanking: {
      root: `${ROOTS.BASE_PATH}/user-management/referral-ranking`,
    },
  },

  swap: {
    root: ROOTS.BASE_PATH,
    transaction: {
      dashboard: {
        root: `${ROOTS.BASE_PATH}/swap-transactions/dashboard`,
      },
      routingStatistics: {
        root: `${ROOTS.BASE_PATH}/swap-transactions/routing-statistics`,
      },
      tokenRouteStatistics: {
        root: `${ROOTS.BASE_PATH}/swap-transactions/token-route-statistics`,
      },
    },
    user: {
      ranking: {
        root: `${ROOTS.BASE_PATH}/swap-users/ranking`,
      },
      detail: {
        root: `${ROOTS.BASE_PATH}/swap-users/detail`,
      },
    },
    chainToken: {
      chainsManagement: {
        root: `${ROOTS.BASE_PATH}/swap-chain-token/chains-management`,
      },
      tokensManagement: {
        root: `${ROOTS.BASE_PATH}/swap-chain-token/tokens-management`,
      },
    },
    config: {
      fee: {
        root: `${ROOTS.BASE_PATH}/swap-config/fee`,
      },
      rango: {
        root: `${ROOTS.BASE_PATH}/swap-config/rango`,
      },
    },
  },
  activity: {
    users: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityUsers}`,
    },
    tasks: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityTasks}`,
    },
    taskCompletionStats: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityTaskCompletionStats}`,
    },
    taskCategories: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityTaskCategories}`,
    },
    tierBenefits: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityTierBenefits}`,
    },
    tierDistribution: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityTierBenefitDistribution}`,
    },
    userActivityStats: {
      root: `${ROOTS.BASE_PATH}/${Resources.activityUserActivityStats}`,
    },
  },
  userRole: {
    root: ROOTS.BASE_PATH,
    userRole: {
      root: `${ROOTS.BASE_PATH}/${Resources.userRole}`,
    },
  },

  agentRebate: {
    root: ROOTS.BASE_PATH,
    agents: {
      root: `${ROOTS.BASE_PATH}/agents`,
    },
    agentInfo: {
      root: `${ROOTS.BASE_PATH}/agent-info`,
    },
    unlimitedAgents: {
      root: `${ROOTS.BASE_PATH}/unlimited-agents`,
    },
    rewardClaims: {
      root: `${ROOTS.BASE_PATH}/${Resources.rewardClaims}`,
    },
    rewardRules: {
      root: `${ROOTS.BASE_PATH}/${Resources.agentRewardRules}`,
    },
  },

  rewards: {
    root: ROOTS.BASE_PATH,
    overview: {
      root: `${ROOTS.BASE_PATH}/rewards-overview`,
    },
    task: {
      root: `${ROOTS.BASE_PATH}/rewards-task`,
    },
  },

  finance: {
    root: ROOTS.BASE_PATH,
    sign: {
      root: `${ROOTS.BASE_PATH}/finance/sign`,
    },
    withdraw: {
      root: `${ROOTS.BASE_PATH}/finance/withdraw`,
    },
    transfers: {
      root: `${ROOTS.BASE_PATH}/finance/transfers`,
    },
    allowlist: {
      root: `${ROOTS.BASE_PATH}/finance/allowlist`,
    },
    limits: {
      root: `${ROOTS.BASE_PATH}/finance/limits`,
    },
    tunkeySetup: {
      root: `${ROOTS.BASE_PATH}/finance/turnkey-config`,
    },
  },

  inviteCodes: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.inviteCodes}`,
    },
    config: {
      root: `${ROOTS.BASE_PATH}/${Resources.inviteBetaCodeConfig}`,
    },
  },

  banners: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.banners}`,
    },
  },

  smallBanners: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.smallBanners}`,
    },
  },

  publishing: {
    announcementPopup: {
      root: ROOTS.BASE_PATH,
      codes: {
        root: `${ROOTS.BASE_PATH}/${Resources.announcementPopup}`,
      },
    },
    linkConfig: {
      root: ROOTS.BASE_PATH,
      codes: {
        root: `${ROOTS.BASE_PATH}/${Resources.linkConfig}`,
      },
    },
    cdnUpload: {
      root: ROOTS.BASE_PATH,
      codes: {
        root: `${ROOTS.BASE_PATH}/${Resources.cdnUpload}`,
      },
    },
    coinImages: {
      root: ROOTS.BASE_PATH,
      codes: {
        root: `${ROOTS.BASE_PATH}/${Resources.coinImages}`,
      },
    },
    coinSymbols: {
      root: ROOTS.BASE_PATH,
      codes: {
        root: `${ROOTS.BASE_PATH}/${Resources.coinSymbols}`,
      },
    },
  },

  hotSearch: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.hotSearch}`,
    },
  },

  hotSymbols: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.hotSymbols}`,
    },
  },

  appVersionManagement: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.appVersionManagement}`,
    },
  },
  domainConfigs: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.domainConfigs}`,
    },
    healthCheckProxy: {
      root: `${ROOTS.BASE_PATH}/${Resources.healthCheckProxy}`,
    },
  },
  relayDeposit: {
    root: ROOTS.BASE_PATH,
    codes: {
      root: `${ROOTS.BASE_PATH}/${Resources.relayDeposit}`,
    },
  },
  redPacket: {
    root: ROOTS.BASE_PATH,
    overview: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketOverview}`,
    },
    type_config: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketTypeConfig}`,
    },
    intervention: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketIntervention}`,
    },
    redpacket_configs: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketredPacketConfig}`,
    },
    records: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketRecords}`,
    },
    lottoDraw_configs: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketLottoDrawConfigs}`,
    },
    designated_redpackets: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketDesignatedRedPackets}`,
    },
    leaderboard_cycles: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketLeaderboardCycles}`,
    },
    daily_prize_pool: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketDailyPrizePool}`,
    },
    daily_prize_pool_status: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketDailyPrizePoolStatus}`,
    },
    daily_prize_pool_config_audit: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketDailyPrizePoolConfigAudit}`,
    },
    feature_flags: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketFeatureFlags}`,
    },
    campaign_dates: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketCampaignDates}`,
    },
    reward_pool_balances: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketRewardPoolBalances}`,
    },
    overlay: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketOverlay}`,
    },
    lucky_lotto_history: {
      root: `${ROOTS.BASE_PATH}/${Resources.redpacketLuckyLottoHistory}`,
    },
  },
  whitelist: {
    root: ROOTS.BASE_PATH,
    candidate: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistCandidate}`,
    },
    reward: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistReward}`,
    },
    faq: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistFaq}`,
    },
    early_bird: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistEarlyBird}`,
    },
    leaderboard: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistLeaderboard}`,
    },
    invite: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistInvite}`,
    },
    manually: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistManually}`,
    },
    redeem: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistRedeem}`,
    },
    users: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistUsers}`,
    },
    eventParticipants: {
      root: `${ROOTS.BASE_PATH}/${Resources.whitelistEventParticipants}`,
    },
  },
  blindBox: {
    root: ROOTS.BASE_PATH,
    overview: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxOverview}`,
    },
    activity_basic: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxActivityBasic}`,
    },
    lucky_wheel: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxLuckyWheel}`,
    },
    blind_box_probability: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxBlindBoxProbability}`,
    },
    trading_tiers: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxTradingTiers}`,
    },
    manual_distribution: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxManualDistribution}`,
    },
    leaderboard: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxLeaderboard}`,
    },
    level_system: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxLevelSystem}`,
    },
    level_probabilities: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxLevelProbabilities}`,
    },
    holiday_lottery: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxHolidayLottery}`,
    },
    holiday_lottery_config: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxHolidayLotteryConfig}`,
    },
    tasks: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxTasks}`,
    },
    winners_ticker: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxWinnersTicker}`,
    },
    win_records: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxWinRecords}`,
    },
    open_sessions: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxOpenSessions}`,
    },
    task_claims: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxTaskClaims}`,
    },
    lottery_tickets: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxLotteryTickets}`,
    },
    user_xp_history: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxUserXpHistory}`,
    },
    spin_box_grant_history: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxSpinBoxGrantHistory}`,
    },
    user_reward_summary: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxUserRewardSummary}`,
    },
    reward_feed: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxRewardFeed}`,
    },
    reward_feed_usdc: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxRewardFeedUsdc}`,
    },
    social_followers: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxSocialFollowers}`,
    },
    withdraw_config: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxWithdrawConfig}`,
    },
    withdrawals: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxWithdrawals}`,
    },
    banned_users: {
      root: `${ROOTS.BASE_PATH}/${Resources.blindBoxBannedUsers}`,
    },
  },
  auditLogs: {
    root: ROOTS.BASE_PATH,
    list: {
      root: `${ROOTS.BASE_PATH}/${Resources.auditLogs}`,
    },
  },
  prediction: {
    root: ROOTS.BASE_PATH,
    system_configs: {
      root: `${ROOTS.BASE_PATH}/${Resources.predictionConfigs}`,
    },
    featured_markets: {
      root: `${ROOTS.BASE_PATH}/${Resources.predictionFeaturedMarkets}`,
    },
  },
  worldCup: {
    root: ROOTS.BASE_PATH,
    overview: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupOverview}`,
    },
    matchData: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupMatchData}`,
    },
    focusMatchConfig: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupFocusMatchConfig}`,
    },
    grandPrixConfig: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupGrandPrixConfig}`,
    },
    leaderboardConfig: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupLeaderboardConfig}`,
    },
    predictionVoucherRule: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupPredictionVoucherRule}`,
    },
    emergencyFuse: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupEmergencyFuse}`,
    },
    faq: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupFaq}`,
    },
    manualIssue: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupManualIssue}`,
    },
    userVouchers: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupUserVouchers}`,
    },
    whitelist: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupWhitelist}`,
    },
    breakingEvents: {
      root: `${ROOTS.BASE_PATH}/${Resources.worldCupBreakingEvents}`,
    },
  },
  turnkeyAddressSearch: {
    root: `${ROOTS.BASE_PATH}/${Resources.turnkeyAddressSearch}`,
  },
  boldPredictionCampaign: {
    configs: {
      root: `${ROOTS.BASE_PATH}/${Resources.boldPredictionCampaignConfigs}`,
    },
    stats: {
      root: `${ROOTS.BASE_PATH}/${Resources.boldPredictionCampaignStatistics}`,
    },
  },
  socialTrading: {
    workbench: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingWorkbench}`,
    },
    accounts: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingAccounts}`,
    },
    users: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingUsers}`,
    },
    agents: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingAgents}`,
    },
    rooms: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRooms}`,
    },
    roomMembers: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRoomMembers}`,
    },
    signals: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingSignals}`,
    },
    intel: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingIntel}`,
    },
    intelCategories: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingIntelCategories}`,
    },
    redpacketLedger: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketLedger}`,
    },
    redpacketConfig: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketConfig}`,
    },
    redpacketPackets: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketPackets}`,
    },
    redpacketLedgerEntries: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketLedgerEntries}`,
    },
    redpacketWithdrawals: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketWithdrawals}`,
    },
    redpacketBalanceReclaim: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketBalanceReclaim}`,
    },
    redpacketPlatformLedger: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketPlatformLedger}`,
    },
    systemConfigs: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingSystemConfigs}`,
    },
    avatarDefaults: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingAvatarDefaults}`,
    },
    redpacketDisplayRules: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingRedpacketDisplayRules}`,
    },
    poolConfig: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingPoolConfig}`,
    },
    agentsConfig: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingAgentsConfig}`,
    },
    pools: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingPools}`,
    },
    poolDashboard: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingPoolDashboard}`,
    },
    poolEnrollments: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingPoolEnrollments}`,
    },
    poolContributions: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingPoolContributions}`,
    },
    poolRewardClaims: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingPoolRewardClaims}`,
    },
    messageStats: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingMessageStats}`,
    },
    audit: {
      root: `${ROOTS.BASE_PATH}/${Resources.socialTradingAudit}`,
    },
  },
};
